'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var uint8ArrayFromString = require('uint8arrays/from-string');
/**
 * @typedef {import('../types').ChunkValidator} ChunkValidator
 */

/**
 * @type {ChunkValidator}
 */


function validateChunks(_x) {
  return _validateChunks.apply(this, arguments);
}

function _validateChunks() {
  _validateChunks = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, content;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(source);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 29;
              break;
            }

            content = _step.value;

            if (!(content.length === undefined)) {
              _context.next = 10;
              break;
            }

            throw errCode(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');

          case 10:
            if (!(typeof content === 'string' || content instanceof String)) {
              _context.next = 15;
              break;
            }

            _context.next = 13;
            return uint8ArrayFromString(content.toString());

          case 13:
            _context.next = 26;
            break;

          case 15:
            if (!Array.isArray(content)) {
              _context.next = 20;
              break;
            }

            _context.next = 18;
            return Uint8Array.from(content);

          case 18:
            _context.next = 26;
            break;

          case 20:
            if (!(content instanceof Uint8Array)) {
              _context.next = 25;
              break;
            }

            _context.next = 23;
            return content;

          case 23:
            _context.next = 26;
            break;

          case 25:
            throw errCode(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');

          case 26:
            _iteratorAbruptCompletion = false;
            _context.next = 4;
            break;

          case 29:
            _context.next = 35;
            break;

          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 35:
            _context.prev = 35;
            _context.prev = 36;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 40;
              break;
            }

            _context.next = 40;
            return _awaitAsyncGenerator(_iterator.return());

          case 40:
            _context.prev = 40;

            if (!_didIteratorError) {
              _context.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context.finish(40);

          case 44:
            return _context.finish(35);

          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 31, 35, 45], [36,, 40, 44]]);
  }));
  return _validateChunks.apply(this, arguments);
}

module.exports = validateChunks;